import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from '@app/shared/constants';
import { environment } from '@env/environment';
import { RequestColor } from '../../models/RequestColor';

@Injectable({
  providedIn: 'root'
})
export class RequestColorService {

  constructor(private http: HttpClient) { }

  SubmitRequestColor(data: RequestColor) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('userToken')
    });
    return this.http.post<any>(environment.baseUrl + AppConstant.SUBMIT_REQUEST_COLOR, data, { headers: headers });
  }
}
